<template>
  <div class="content">
    <base-header class="">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 d-none d-md-inline-block">
          <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
        </div>
      </div>
    </base-header>

    <box-loader :loading="loading">
      <div class="container-fluid">
        <div class="form_laive">
          <div class="box_loader">
            <div class="loader"></div>
          </div>
          <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
            <template #header>
              <div class="row">
                <div class="col-12 col-md-6">
                  <h3 class="mb-0">Cargar Producto Iniciativa</h3>
                </div>
              </div>
            </template>
            <div class="px-3 pb-3">
              <form @submit.prevent="submitCsv" class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="col-form-label form-control-label">Archivo:</label>
                    <file-input :key="fileInputKey" @change="onChangeFile" required accept="text/csv,.csv" />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="d-flex align-item-center">
                    <base-button type="primary" native-type="submit" class="btn-default my-0">
                      Cargar Producto Iniciativa
                    </base-button>
                    <a
                      class="th-btn th-btn-border-pry text-sm align-items-center d-flex flex-row"
                      href="/plantillas/producto-iniciativa-plantilla.csv"
                      download
                    >
                      Descargar plantilla
                      <i class="laive-i icon-download ml-2" />
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </card>
        </div>
      </div>
    </box-loader>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { useAppToast } from "../../composables";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import FileInput from "@/components/Inputs/FileInput";
import DashboardNavbar from "../Layout/DashboardNavbar";
import { serviceMaestroCarga } from "../../services/maestroCarga";

const toast = useAppToast();

export default {
  components: {
    DashboardNavbar,
    RouteBreadCrumb,
    FileInput,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  data() {
    return {
      loading: false,
      file: null,
      fileInputKey: 0,
    };
  },
  methods: {
    async submitCsv() {
      try {
        this.loading = true;
        if (!this.file) {
          toast.error("Seleccione el archivo CSV");
          return;
        }
        const isCsv = this.file.type === "text/csv" || (this.file.name || "").toLowerCase().endsWith(".csv");
        if (!isCsv) {
          toast.error("El archivo debe ser .csv");
          return;
        }

        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("CreatedBy", this.user.nombre);

        await serviceMaestroCarga.uploadProductoIniciativa(formData);

        this.file = null;
        this.fileInputKey += 1;

        toast.success("Se subió correctamente el archivo CSV de iniciativas");
      } catch {
        toast.error("Hubo un problema con la carga del archivo");
      } finally {
        this.loading = false;
      }
    },
    onChangeFile(files) {
      this.file = files && files.length > 0 ? files[0] : null;
    },
  },
};
</script>

<style lang="scss">
.page-item .page-link .fa {
  z-index: 0;
}

.notes_editor {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;

  p {
    margin: 0;
  }

  ul {
    padding-left: 1.5rem;
  }
}
</style>
